package com.kinoshazam

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidedValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.text.intl.Locale
import kotlinx.browser.window

/**
 * Web locale override for Compose Resources.
 * Must set `window.__customLocale` before reading [Locale.current], then remount via `key(locale)`
 * (see [com.kinoshazam.uiKit.theme.ProviderCompositionLocal]). Matches JetBrains workaround:
 * https://kotlinlang.org/docs/multiplatform/compose-resource-environment.html
 */
actual object LocalAppLocale {
    private val LocalAppLocaleComposition = staticCompositionLocalOf { Locale.current }

    actual val current: String
        @Composable get() = LocalAppLocaleComposition.current.toString()

    @Composable
    actual infix fun provides(value: String?): ProvidedValue<*> {
        window.asDynamic().__customLocale = value?.replace('_', '-')
        // Re-read after override so provided value matches resource environment.
        return LocalAppLocaleComposition.provides(Locale.current)
    }
}
